import React from 'react';
import PropTypes from 'prop-types';

import {
    AvatarTextBlock,
    AvatarInputContainer,
    AvatarWrapper,
    AvatarDescriptionText,
    UploadText,
    AvatarPreview,
} from './style';
import { Row } from '../../../Layouts';
import { Icon } from '../../Icons/Icons';

export const AvatarInput = ({ preview, name, onChange }) => (
    <AvatarWrapper htmlFor={name}>
        <AvatarInputContainer>
            {preview ? (
                <AvatarPreview background={preview} />
            ) : (
                <Icon.Box cursor={'pointer'} size={'82x82'} margin={'0'}>
                    <Icon.FakeImageAvatar />
                </Icon.Box>
            )}
            <AvatarTextBlock>{preview ? 'Change' : 'Add'}</AvatarTextBlock>

            <input onChange={onChange} name={name} id={name} type={'file'} style={{ display: 'none' }} />
        </AvatarInputContainer>

        <Row>
            <AvatarDescriptionText marginRight={'12px'}>Add a profile photo</AvatarDescriptionText>
            <UploadText>Upload</UploadText>
        </Row>
    </AvatarWrapper>
);

AvatarInput.defaultProps = {
    onChange: () => {},
    name: '',
};

AvatarInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,

    preview: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/UI/Components/forms/AuthenticationForms/AvatarInput.js